<style scoped lang="less">
@import "/lib/Colors.less";
.attachment-group {
    .form-control {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
}
.attachment-bar {
    display: flex;
    align-items: center;
    background: #f5f5f5;
    padding: 2.5px;
    border: 1px solid #ced4da;
    border-top: none;
    border-radius: 0 0 0.25rem 0.25rem;
    &:before {
        position: absolute;
        font-size: 1.1em;
        padding: 7.5px 7.5px 5px 5px;
        pointer-events: none;
    }
    input {
        display: flex;
        padding-left: 30px;
        font-size: 0.85em;
    }
}
.visibility-input-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    width: auto;
    height: auto;
    padding: 0;
    font-size: 0.9em;
    .icon {
        &:before {
            margin-right: 5px;
        }
    }
    .btn {
        display: flex;
        align-items: center;
        padding: 0 4px;
    }
}
.icon-sites:before {
    color: @primary-blue-v2;
}
.disabled-visibility {
    cursor: not-allowed !important;
    .visibility-input {
        pointer-events: none;
    }
}
.dropdown-menu {
    right: 0;
    left: auto;
    white-space: nowrap;
    padding: 10px 15px;
    font-size: 0.875rem;
    .icon {
        display: inline-flex;
        align-items: center;
    }
}
.comment-username {
    display: block;
    line-height: 100%;
    margin-bottom: 5px;
}
.comment-list {
    padding: 0;
    margin: 0 0 5px 0;
    list-style: none;
}
.comment-list-heading {
    display: block;
    margin-top: 0;
    margin-bottom: 20px;
}
.comment-card {
    margin-top: 5px;
    display: block;
    padding: 7.5px;
    float: left;
    width: 100%;
}
.comment-btn {
    margin-top: 7.5px;
}
.comment-icon-btn {
    display: inline-block;
    margin-top: 5px;
    padding: 0;
    text-decoration: none !important;
    line-height: 0;
    font-size: 1.1em;
}
.submissions-comment {
    padding: 10px;
    border-bottom: 1px solid #cccccc;
    .comment-text {
        margin: 0;
    }
    .help-block {
        white-space: nowrap;
        display: block;
    }
    &:first-of-type {
        margin-top: 0;
    }
}
.btn-outline-secondary {
    &:not(:focus, :hover) {
        background-color: #ffffff;
    }
}
.btn-bare {
    font-weight: bold;
    font-size: 16px;
}
/deep/ .help-button {
    margin-right: 5px;
    cursor: not-allowed;
}
/deep/ .disabled-help-overlay {
    // overlay help icon on disabled inputs for better reliability on click
    .help-button .icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 30px;
        background: none;
        outline: none !important;
        &:before {
            display: none;
        }
    }
    .popper {
        min-width: 200px;
    }
}
.field-validation-error {
    .icon.icon-attention {
        color: inherit;
    }
}
</style>
<template>
    <div v-if="showComponent" :class="hasComments || hasHistory ? ['card', 'card-body', 'comment-card'] : []">
        <!-- TODO move? -->
        <template v-if="data.history.length > 0 && !hideHistory">
            <div @click="toggleHistoryVisibility">
                <button @click.prevent.stop="toggleHistoryVisibility" class="btn btn-bare p-0" :aria-expanded="historyVisibility" :aria-controls="id + '-history-list'" :id="id + 'history-header'">
                    History
                    <span class="icon" :class="[historyVisibility ? 'icon-caret-up' : 'icon-caret-down']"></span>
                </button>
            </div>
            <ul class="comment-list" v-show="historyVisibility" role="region" :id="id + '-history-list'" :aria-labelledby="id + 'history-header'">
                <li class="submissions-comment p-relative" v-for="comment in data.history">
                    <strong class="fw-600 comment-username">{{ comment.userName || "Anonymous" }}</strong>
                    <span class="help-block p-0">{{ new Date(comment.date).toLocaleString() }}</span>
                    <div class="comment-text">{{ comment.text }}</div>
                </li>
            </ul>
        </template>
        <template v-if="data.comments.length > 0">
            <div @click="toggleCommentsVisibility" v-if="!hideHistory">
                <button @click.prevent.stop="toggleCommentsVisibility" class="btn btn-bare p-0" :aria-expanded="commentsVisibility" :aria-controls="id + '-comment-list'" :id="id + 'comment-header'">
                    Comments
                    <span class="icon" :class="[commentsVisibility ? 'icon-caret-up' : 'icon-caret-down']"></span>
                </button>
            </div>
            <ul class="comment-list" v-show="commentsVisibility || hideHistory" role="region" :id="id + '-comment-list'" :aria-labelledby="id + 'comment-header'">
                <Comment :id="id" :comment="comment" :hide-history="hideHistory" @set-comment-visibility="toggleCommentVisibility(comment, $event as boolean)" @delete-comment="deleteComment(comment)" :key="comment.id != '00000000-0000-0000-0000-000000000000' ? comment.id : generateGuid()" v-for="comment in data.comments" />
            </ul>
        </template>
        <template v-if="showAddComments || showChangeStatus">
            <div :class="(hideHistory || commentsVisibility || !hasComments) && !showReply ? 'd-inline' : 'd-none'" @click.prevent="showComments">
                <!-- <button :id="id + '_ShowAddCommentBtn'" type="button" class="btn btn-outline-secondary comment-btn btn-sm mb-3 mt-1" v-if="showAdminFormLevelControls">
                    {{ showAdminFormLevelControls && showChangeStatus ? "Update" : "Add Comment" }}
                </button> -->
                <button :id="id + '_ShowAddCommentBtn'" type="button" class="btn btn-outline-secondary comment-btn btn-sm mt-1" v-if="!showAdminFormLevelControls && hasComments">Reply</button>
                <button :id="id + '_ShowAddCommentBtn'" type="button" class="passthrough icon icon-comment comment-icon-btn" v-else-if="!showAdminFormLevelControls && !hasComments">
                    <span class="sr-only">Add Comment</span>
                </button>
            </div>
            <div class="mt-1" :class="!adminReview ? null : newVisibleToSubmitter ? 'submitter-visible-comment' : 'reviewer-visible-comment'" v-show="(hideHistory || commentsVisibility || !hasComments) && (showAdminFormLevelControls || showReply)">
                <div class="attachment-group mb-1" v-if="showAddComments">
                    <label :for="id + '_ReplyText'" class="sr-only">Comment</label>
                    <textarea class="form-control" :id="id + '_ReplyText'" ref="replyText" v-model="newText" placeholder="Add a comment..."></textarea>
                    <div class="attachment-bar icon icon-attach">
                        <label :for="id + '_File'" class="sr-only">Attach Files</label>
                        <input type="file" :id="id + '_File'" ref="file" multiple />
                        <div v-if="adminReview" class="d-inline-flex ml-auto">
                            <div class="visibility-input-wrapper dropdown" :class="hideHistory ? 'disabled-visibility' : ''" v-if="adminReview">
                                <button type="button" class="btn btn-outline-secondary btn-sm dropdown-toggle" :class="{ show: newVisibleToSubmitterVisibilityEditing }" @click.prevent.stop="newVisibleToSubmitterVisibilityEditing = !newVisibleToSubmitterVisibilityEditing" :disabled="hideHistory"><span class="icon" :class="newVisibleToSubmitter && !hideHistory ? 'icon-sites' : 'icon-users'"></span>{{ (hideHistory ? isReturned : newVisibleToSubmitter) ? "Everyone" : "Reviewers only" }}</button>
                                <fieldset class="dropdown-menu" @click.stop>
                                    <legend class="sr-only">Comment Visibility</legend>
                                    <div class="form-check">
                                        <input type="radio" class="form-check-input" :name="'CommentVisibility_' + id" v-model="newVisibleToSubmitter" :value="true" :id="id + '_Everyone'" @change="newVisibleToSubmitterVisibilityEditing = false" />
                                        <label class="form-check-label" :for="id + '_Everyone'"><span class="icon icon-sites"></span>Everyone</label>
                                    </div>
                                    <div class="form-check">
                                        <input type="radio" class="form-check-input" :name="'CommentVisibility_' + id" v-model="newVisibleToSubmitter" :value="false" :id="id + '_Reviewers'" @change="newVisibleToSubmitterVisibilityEditing = false" />
                                        <label class="form-check-label" :for="id + '_Reviewers'"><span class="icon icon-users"></span>Reviewers only</label>
                                    </div>
                                </fieldset>
                                <HelpIcon v-if="hideHistory" class="disabled-help-overlay" :text="(isReturned ? 'Comments added for returns will only be included in the notification to the Submitter.' : 'Comments in this tab are only visible to Reviewers.') + ' Add comments to specific fields to inform the Submitter.'" :hover="false" />
                            </div>
                        </div>
                    </div>
                    <div v-if="anyThreat">
                        <span class="field-validation-error"><i class="icon icon-attention align-middle mr-1" title="Error" role="img" />Potential virus or malware detected.</span>
                    </div>
                </div>
                <!--<div class="form-group" v-if="showChangeStatus">
                    <label :for="id + '_Status'">Change status to</label>
                    <select name="status" :id="id + '_Status'" class="form-control" v-model="newStatus">
                        <option :value="null">No Change ({{ currentStatusLabel }})</option>
                        <option :value="status.value" :disabled="isStatusDisabled(status)" :title="getStatusDisabledReason(status)" v-for="status in possibleStatusesExcludingIgnored">{{ status.text || status.value }}{{ isStatusDisabled(status) ? " (Unavailable)" : "" }}</option>
                    </select>
                </div>-->
                <button :id="id + '_SendReplyBtn'" type="button" class="btn btn-primary btn-sm" @click.prevent="sendReply">Add</button>
                <button type="button" class="btn btn-link btn-sm" style="color: inherit" @click.prevent="cancel">Cancel</button>
                <LoadingWheel v-if="commentStatus == 'sending'" :width="16" style="display: inline-block" />
            </div>
            <div aria-live="polite" class="sr-only">
                <template v-if="commentStatus && commentStatus != 'sending'">
                    <span v-if="anyThreat">Error: Potential virus or malware detected.</span>
                    <span v-else>File uploaded successfully</span>
                </template>
            </div>
        </template>
    </div>
</template>
<script lang="ts">
import { defineComponent, inject, computed, ref, watch, /*onActivated, onMounted,*/ nextTick, SetupContext } from "vue";
import { usePageStore } from "../pageState/store";
//import { useObservable } from "@vueuse/rxjs";
//import { computedAsync } from "@vueuse/core";
//import { map } from "rxjs/operators";
//import { Status as FormDefStatus } from "@cs-ts/status";
import LoadingWheel from "@/lib/LoadingWheel.3.vue";
import CommentComponent from "./Comment.3.vue";
import { Comment } from "@cs-ts/comment";
import HelpIcon from "@/lib/HelpIcon.3.vue";
import generateGuid from "../.././../lib/generateGuid";
import { BaseElementDefBase } from "../elements/BaseElementDef";
import { gotoIndexInjectKey } from "../Page.3.vue.InjectKeys";
import { throwIfNonSuccessStatus } from "@/lib/fetchHelpers.3";
import { getXsftHeader } from "@/lib/getXsrfToken.3";
import { useMainStore } from "@/mainStore";
import { FormComment } from "@/cs-ts-bridge/ts/form-comment";
interface EditingComment extends Comment {
    visibleToSubmitterEditing: boolean;
}
interface Props {
    data: BaseElementDefBase & { isThreat: boolean };
    //    {
    //    isThreat: boolean,
    //    history: HistoryBase[];
    //    comments: EditingComment[];
    //};
    showAdminFormLevelControls: boolean;
    hideHistory: boolean;
}
export default defineComponent({
    props: ["data", "showAdminFormLevelControls", "hideHistory"],
    components: {
        Comment: CommentComponent,
        LoadingWheel,
        HelpIcon,
    },
    setup(props: Props, { emit }: SetupContext) {
        const pageStore = usePageStore();
        const mainStore = useMainStore();
        const id = ref(generateGuid());
        const showReply = ref(false);
        const newVisibleToSubmitter = ref(!pageStore.adminReview);
        const newVisibleToSubmitterVisibilityEditing = ref(false);
        const newText = ref(undefined as undefined | string);
        const newStatus = ref(null as null | string);
        const commentStatus = ref(null as null | "sending" | "ok" | "failed");
        const historyVisibility = ref(false);
        const commentsVisibility = ref(false);
        const anyThreat = ref(false);
        const fileRef = ref(null! as HTMLInputElement);
        const replyTextRef = ref(null! as HTMLInputElement);

        const gotoIndex = inject(gotoIndexInjectKey)!;

        watch(
            () => props.data,
            //eslint-disable-next-line @typescript-eslint/no-explicit-any
            (newData: any, _oldData: any) => {
                for (let comment of (newData.comments || []) as EditingComment[]) {
                    if (comment.visibleToSubmitterEditing == null) {
                        comment.visibleToSubmitterEditing = comment.visibleToSubmitterEditing || false;
                    }
                }
            },
        );

        const adminReview = computed(() => pageStore.adminReview);
        //const possibleStatusesExcludingIgnored = computed(() => {
        //    return pageStore.possibleStatuses.filter(i => !ignoredStatuses.some(j => j == i.value));
        //});
        const showComponent = computed(() => {
            return hasComments.value || pageStore.canAddComments || pageStore.canChangeStatus || hasHistory.value;
        });
        const showAddComments = computed(() => {
            return (hasComments.value && pageStore.canReplyToComments) || pageStore.canAddComments || pageStore.canChangeStatus;
        });
        const showChangeStatus = computed(() => {
            return pageStore.canChangeStatus && props.showAdminFormLevelControls && !pageStore.isWorkflow;
        });
        const hasComments = computed(() => {
            return props.data.comments != null && props.data.comments.length > 0;
        });
        const hasHistory = computed(() => {
            return props.hideHistory ? false : props.data.history != null && props.data.history.length > 0;
        });
        const isReturned = computed(() => {
            return newStatus.value == "Returned";
        });
        const formDataTyped = computed(() => pageStore.formDataTyped!);
        const toggleCommentsVisibility = () => {
            commentsVisibility.value = !commentsVisibility.value;
        };
        const toggleHistoryVisibility = () => {
            historyVisibility.value = !historyVisibility.value;
        };
        //const isStatusDisabled = (status: FormDefStatus) => {
        //    if (status.value == returnedStatus && pageStore.anonymousUser) {
        //        return true;
        //    }
        //    return false;
        //};
        //const getStatusDisabledReason = (status: FormDefStatus) => {
        //    if (status.value == returnedStatus && pageStore.anonymousUser) {
        //        return "Cannot return submission.value because the submitter wasn't logged in";
        //    }
        //    return null;
        //};
        const showComments = () => {
            showReply.value = true;
            nextTick(() => {
                replyTextRef.value.focus();
            });
        };
        const toggleCommentVisibility = async (comment: EditingComment, val: boolean) => {
            comment.visibleToSubmitterEditing = false;
            const newVisibleToSubmitter = val;
            const elementId = pageStore.getElementPathString(props.data);
            await pageStore.setCommentVisibility({ visibleToSubmitter: newVisibleToSubmitter, elementId, commentId: comment.id, elementData: props.data });
        };
        const cancel = () => {
            if (props.showAdminFormLevelControls) {
                newText.value = undefined;
                fileRef.value.value = null!;
            } else {
                showReply.value = false;
            }
        };
        const sendReply = async () => {
            commentStatus.value = "sending";
            const elementId = pageStore.getElementPathString(props.data);
            try {
                const htmlFiles = Array.from(fileRef.value.files as unknown as File[]);
                const filesPromises = htmlFiles.map(async i => (await pageStore.uploadExternalFile({ vmId: props.data.vmId, newFile: i, isComment: true }))!);
                const fileObjects = await Promise.all(filesPromises);
                const fileIds = fileObjects.map(i => i.valueId);
                anyThreat.value = fileObjects.some(i => i.isThreat);
                if (anyThreat.value) {
                    throw new Error("Potential virus or malware detected.");
                }
                const fileNames = htmlFiles.map(i => i.name);
                const fileContentTypes = htmlFiles.map(i => i.type);
                const visibleToSubmitter = props.hideHistory ? (isReturned.value ? true : false) : adminReview.value ? newVisibleToSubmitter.value : true;
                const response = await pageStore.addCommentAndChangeStatus({ text: newText.value!, visibleToSubmitter, elementId, elementData: props.data, status: newStatus.value!, fileIds, fileNames, fileContentTypes, userName: "Myself" });
                if (response && !response.accessible) {
                    alert("As a result of your change, this submission is no longer accessible.");
                    if (gotoIndex != null) {
                        gotoIndex();
                    } else {
                        emit("change-page", { page: "AdminSearch" });
                    }
                    return;
                }
                //@ts-expect-error
                fileRef.value.value = null; // clear attachments
                showReply.value = false;
                newText.value = undefined;
                newStatus.value = null;
                commentStatus.value = "ok";
            } catch (e) {
                commentStatus.value = "failed";
                alert("Saving comment failed");
                throw e;
            }
        };
        const deleteComment = async (comment: FormComment) => {
            if (!confirm("Delete comment?")) {
                return;
            }
            const elementId = pageStore.getElementPathString(props.data);
            const _formData = {
                elementId,
                pageNumber: 1,
                formId: formDataTyped.value.formId,
                commentId: comment.id,
            };
            const formData = new FormData();
            for (const key of Object.keys(_formData)) {
                //@ts-ignore
                formData.append(key, _formData[key]);
            }
            const deleteCommentUrl = await mainStore.getUrl("deleteComment", { tenantCode: pageStore.formTenantCode, formId: pageStore.formId });
            const deleteResponse = await fetch(deleteCommentUrl, {
                method: "POST",
                headers: await getXsftHeader(mainStore),
                credentials: "same-origin",
                body: formData,
            });
            throwIfNonSuccessStatus(deleteResponse);
            //eslint-disable-next-line vue/no-mutating-props
            props.data.comments.splice(
                props.data.comments.findIndex(c => comment.id == c.id),
                1,
            );
        };

        return {
            replyText: replyTextRef,
            file: fileRef,
            showComponent,
            hasComments,
            hasHistory,
            toggleHistoryVisibility,
            id,
            historyVisibility,
            toggleCommentsVisibility,
            toggleCommentVisibility,
            commentsVisibility,
            showAddComments,
            showChangeStatus,
            generateGuid,
            showReply,
            showComments,
            adminReview,
            newVisibleToSubmitterVisibilityEditing,
            newVisibleToSubmitter,
            newText,
            isReturned,
            commentStatus,
            sendReply,
            anyThreat,
            cancel,
            deleteComment,
        };
    },
});
</script>
